import styled from "styled-components";

import theme from "../../../../theme";

export interface IStepBarProps {
  horizontalPadding?: number;
}

const VerticalStepBar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:before,
  &:after {
    content: "";
    display: block;
    flex-grow: 1;
    width: 1px;
    background-color: ${theme.colors.brown};
  }
`;

export default VerticalStepBar;
